import { makeStyles, withStyles } from '@material-ui/core/styles';
import StepConnector from '@material-ui/core/StepConnector';

const black = '#000';
const white = '#fff';
const lightGray = '#C2C2C2';
const darkGray = '#929292';
const bgColor = '#fafafa';
const graySectionColor = '#f3f3f3';
const graySectionTextColor = '#b8b8b8';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        color: '#000',
        [theme.breakpoints.down('1024')]: {
            height: 'inherit'
        }
    },
    formRoot: {
        width: '62.71%',
        [theme.breakpoints.down('sm')]: {
            width: '100vw'
        }
    },
    sidePreview: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        right: 0,
        width: '37.29%',
        height: '100vh',
        backgroundColor: '#fff',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px;',
        '& p': {
            padding: '0',
            margin: '5px 0'
        },
        '& iframe': {
            border: 'none'
        }
    },
    title: {
        marginTop: '32px',
        marginBottom: '52px',
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#fafafa',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            // marginBottom: '40px',
            // marginTop: '16px'
        },
        [theme.breakpoints.down('767')]: {
            marginBottom: 0
        },
        [theme.breakpoints.between('sm', 'md')]: {
            fontSize: '32px'
        },
        [theme.breakpoints.between('md', 'lg')]: {
            fontSize: '36px'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '40px'
        },
    },
    form: {
        width: '78.41%',
        margin: '0 auto',
        '&.gray-section': {
            [theme.breakpoints.up('sm')]: {
                width: '100%',
                '& .grayViewContainer[class*="wrapFieldsAround"]': {
                    width: '100%',
                    marginRight: 0,
                    marginLeft: 0,
                    '& [class*="inputContainer"]': {
                        '&.grayView': {
                            width: '100%',
                            '& [class*="inputContainer"]': {
                                textAlign: 'center',
                                '&:not(.grayBg)': {
                                    width: '310px'
                                }
                            },
                            '& .sectionTitle': {
                                marginTop: '72px'
                            },
                            '& [class*="fullWidthButton"]': {
                                width: '310px'
                            },
                            '& [class*="inviteDownloadContainer"], & [class*="inputTitleContainer"]': {
                                width: '310px',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                '& div': {
                                    width: 'inherit',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }
                            },
                            '& [class*="linkContainer"]': {
                                width: 'calc(310px - 32px)',
                                '& div': {
                                    width: 'inherit',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }
                            },
                            '& [class*="readyToParty"]': {
                                background: graySectionColor,
                                '& .subTitle': {
                                    color: graySectionTextColor
                                },
                                '& div': {
                                    background: 'inherit!important'
                                },
                                width: '100%',
                                '& [class*="fullWidthButton"]': {
                                    width: '310px'
                                }
                            }
                        }
                    }
                },
                '& [class*="stepper"]': {
                    width: '78.41%',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                }
            }
        }
    },
    stepper: {
        marginBottom: '64px',
        padding: '1px',
        backgroundColor: '#fafafa',
        [theme.breakpoints.only('sm')]: {
            marginBottom: '36px',
        },
    },
    stepIcon: {
        color: '#fff',
        fontSize: '35px',
        borderRadius: '50%',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%)',
        '& $text': {
            fill: '#C2C2C2',
            fontSize: '10px'
        }
    },
    alternativeLabel: {
        textTransform: 'uppercase',
        fontWeight: 'bold !important',
        color: '#ADADAD'
    },
    activeIcon: {
        fill: '#000',
        '& $text': {
            fill: '#fff'
        }
    },
    completedIcon: {
        color: "#000"
    },
    inputContainer: {
        width: '310px',
        margin: '0 auto',
        backgroundColor: '#fafafa',
        [theme.breakpoints.down('385')]: {
            width: '100%'
        },
        '& input, & textarea': {
            fontSize: '14px',
            fontWeight: '500'
        },
        '& .MuiBox-root': {
            width: '100%'
        }
    },
    inputTitleContainer: {
        backgroundColor: '#fafafa',
        marginBottom: '12px'
    },
    inputTitleText: {
        fontWeight: 'bold'
    },
    inputFieldContainer: {
        width: 'calc(100% - 32px)',
        maxHeight: '30px',
        margin: '0',
        marginBottom: '32px',
        backgroundColor: '#fff',
        borderColor: '#fafafa',
        borderRadius: '11px',
        padding: '14px 16px',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%)',
        '& button': {
            padding: '0'
        },
        '& .MuiFormHelperText-root.Mui-error': {
            position: 'relative',
            top: '-9px'
        }
    },
    inputChurchFieldContainer: {
        width: 'calc(100% - 30px)',
        margin: '0',
        marginBottom: '32px',
        backgroundColor: '#fff',
        borderColor: '#fafafa',
        borderRadius: '11px',
        padding: '14px 16px',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%)',
        '& button': {
            padding: '0'
        }
    },
    smIconsContainer: {
        backgroundColor: 'inherit',
        '& svg': {
            fontSize: '30px',
            padding: '12px 12px 0 12px',
            '&:first-child': {
                paddingLeft: '0'
            },
            '&:last-child': {
                paddingRight: '0'
            }
        },
        [theme.breakpoints.up('sm')]: {
            marginBottom: '100px'
        }
    },
    nextButton: {
        fontWeight: 'bold',
        borderRadius: '20px',
        height: '40px',
        paddingLeft: '24px',
        paddingRight: '16px',
        '&:disabled': {
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.32)',
        },
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '& svg': {
            position: 'relative',
            left: '8px',
            [theme.breakpoints.down('332')]: {
                left: '2px'
            },
        },
        '&:only-child': {
            margin: '0 auto'
        },
        [theme.breakpoints.down('332')]: {
            paddingRight: '12px',
            paddingLeft: '20px'
        },
    },
    prevButton: {
        fontWeight: 'bold',
        borderRadius: '20px',
        height: '40px',
        paddingRight: '24px',
        paddingLeft: '16px',
        '&:disabled': {
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.32)',
        },
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '& svg': {
            position: 'relative',
            right: '8px',
            [theme.breakpoints.down('332')]: {
                right: '2px'
            }
        },
        [theme.breakpoints.down('332')]: {
            paddingRight: '20px',
            paddingLeft: '12px'
        }
    },
    fullWidthButton: {
        fontWeight: 'bold',
        borderRadius: '20px',
        width: '100%',
        height: '40px',
        marginTop: 0,
        marginBottom: '52px',
        paddingLeft: '24px',
        paddingRight: '16px',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '& a': {
            textDecoration: 'none'
        },
        '& a.MuiLink-underlineHover': {
            textDecoration: 'none'
        },
        '&.firstBtn': {
            [theme.breakpoints.up('sm')]: {
                marginBottom: '100px'
            }
        },
        '&.secondBtn': {
            marginTop: '43px',
            marginBottom: 0,
            '&+.next-btn': {
                display: "block",
                marginTop: '20px',
                marginBottom: '52px',
                textAlign: 'center',
                fontFamily: 'Poppins',
                fontWeight: '600',
                fontSize: '14px',
                color: '#000',
                [theme.breakpoints.up('sm')]: {
                    marginBottom: '100px'
                },
            },
            [theme.breakpoints.up('sm')]: {
                marginBottom: 0
            },
        },
        '&.lastBtn': {
            marginTop: '52px',
            [theme.breakpoints.up('sm')]: {
                marginBottom: '100px',
                marginTop: 0
            },
        }
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
        width: '310px',
        display: 'flex',
        justifyContent: 'space-between',
        margin: '0 auto',
        [theme.breakpoints.down('385')]: {
            width: '100%'
        }
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    inviteDownloadContainer: {
        backgroundColor: bgColor,
        // flexBasis: 'auto !important',
        padding: '0 !important',
        width: 'inherit',
        '& svg': {
            paddingTop: 0
        },
        [theme.breakpoints.up('sm')]: {
            textAlign: 'center',
            '& [class*="inputTitleText"]': {
                marginBottom: '56px'
            },
            '& .sectionTitle': {               
                fontSize: '20px'
            }
        }
    },
    inviteDownload: {
        width: '256px',
        height: '277px',
        borderRadius: '20px'
    },
    noPadding: {
        padding: '0 !important'
    },
    wrapFields: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    wrapFieldsAround: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    mobileContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        width: '100%',
        paddingTop: '15px',
        fontSize: '14px',
        fontWeight: 'bold',
        fontFamily: 'Poppins',
        backgroundColor: bgColor
    },
    mobileStepLabel: {
        display: 'inherit',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
        fontFamily: 'inherit',
        '& p': {
            fontSize: 'inherit',
            fontWeight: 'inherit',
            marginLeft: '10px',
            textTransform: 'uppercase'
        },
        '& div': {
            display: 'inline-block',
            padding: 0,
            '&:first-letter': {
                color: white,
                backgroundColor: black,
                borderRadius: '50%',
                padding: '0 6px'
            },
        }
    },
    mobilePreviewMessage: {
        fontSize: 'inherit',
        fontWeight: 'inherit',
        color: lightGray,
        '& span': {
            color: black
        },
        marginTop: '24px',
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
            marginBottom: '24px'
        },
    },
    mobilePreviewBtn: {
        width: '143px',
        height: '40px',
        fontWeight: 'inherit',
        color: black,
        backgroundColor: white,
        padding: '0 40px',
        marginTop: '32px',
        marginBottom: '32px',
        borderRadius: '20px',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '&:disabled, &:hover': {
            color: darkGray,
            backgroundColor: white
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
            marginBottom: '64px'
        },
    },
    mobileClosePreviewBtn: {
        position: 'absolute',
        top: '70px',
        margin: '0 auto',
        left: 0,
        right: 0,
        fontWeight: 'bold',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 25%) !important'
    },
    partyImage: {
        marginTop: '36px',
        marginBottom: '36px'
    },
    linkContainer: {
        width: '100%',
        marginTop: 0
    },
    copyContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '24px',
        '& p': {
            fontSize: '14px',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        }
    },
    copyBtn: {
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '1.5',
        paddingLeft: '10px'
    },
    bgColor: {
        backgroundColor: bgColor
    },
    mb8: {
        marginBottom: '8px'
    },
    mb20: {
        marginBottom: '20px'
    },
    mobileMt56: {
        [theme.breakpoints.down('768')]: {
            marginTop: '56px !important'
        }
    },
    noMaxHeight: {
        maxHeight: 'none'
    },
    checkbox: {
        '& span.MuiFormControlLabel-label': {
            fontSize: '16px !important',
            fontFamily: 'Poppins',
            fontWeight: 'bold'
        },
        marginBottom: '10px',
        '& span.MuiButtonBase-root': {
            color: '#fff'
        },
        '& span.MuiIconButton-label': {
            backgroundColor: '#fff',
            boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%)',
            width: '30px',
            height: '30px',
            borderRadius: '8px'
        },
        '&.login': {
            '& span.MuiFormControlLabel-label': {
                fontFamily: 'Poppins',
                fontSize: '13px !important',
                fontWeight: '600'
            }
        },
        '& .tooltip': {
            display: 'flex',
            '& svg': { marginLeft: '5px' }
        }
    },
    readyToParty: {
        fontSize: '16px',
        width: 'inherit',
        '& p': {
            fontWeight: 'bold',
            margin: 0,
            padding: 0
        },
        '& .sectionTitle': {
            fontSize: 'inherit',
            [theme.breakpoints.up('sm')]: {
                fontSize: '20px'
            }
        },
        '& .subTitle': {
            fontSize: '14px',
            color: lightGray,
            marginTop: '2px',
            fontWeight: 600,
            marginBottom: '37px',
            '& a': {
                color: '#122AFF'
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '16px'
            },
        },
        [theme.breakpoints.up('sm')]: {
            textAlign: 'center',
            // fontSize: '20px'
        },
    },
    center: {
        display: 'block',
        margin: '0 auto'
    }
}));

const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 14
    },
    active: {
      '& $line': {
        backgroundColor: '#000'
      },
    },
    completed: {
      '& $line': {
        backgroundColor: '#000'
      },
    },
    line: {
      height: 5,
      border: 0,
      backgroundColor: '#fff',
      borderRadius: 1,
      boxShadow: '0 3px 6px 0 rgb(0 0 0 / 7%)',
    },
})(StepConnector);

export { useStyles, ColorlibConnector };